import tabularDataToCsv from 'common/src/modules/shared/copilot/csvUtils/tabularDataToCsv';
import excelToCampaignApi from 'common/src/modules/excelToCampaign/excelToCampaign.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ExcelToCampaignAgentToolName} from './excelImport.enums';

const inputSchema = z.object({
  campaignId: z.number(),
  versionId: z.number(),
});

function getCampaignSignalsTool() {
  async function execute({
    input: {campaignId, versionId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const signals = await excelToCampaignApi.getCampaignSignals({
      campaignId,
      versionId,
    });

    return toolResult(tabularDataToCsv(signals));
  }

  return tool({
    name: ExcelToCampaignAgentToolName.GetCampaignSignals,
    description: 'Fetches available campaign signals for mapping.',
    execute,
    displayName: 'Reading campaign',
    inputSchema,
    isReadonly: true,
  });
}

export default getCampaignSignalsTool;
